import React, { memo, useMemo } from "react";
import { Card, Col, Row, Typography, Steps, Divider } from "antd";
import {
  ShipmentStatus,
  LoadStatusMap,
  TrackingStatus,
  LoadStatusToTrackingStatusMap,
} from "../../utils/enums";
import PickupDropOffSteps from "../PickupDropOffSteps";
import { VehiclesTable, DriverTable } from "../Tables";
import ETAsDescription from "../ETAsDescription";
import GoogleMap from "../GoogleMap";
import "./Card.styles.css";

const { Title } = Typography;

export default memo(function ActiveLoadCard({
  loadStatus,
  shipmentStatus,
  vehicles,
  pickupAddress,
  dropOffAddress,
  loadLocation,
  loadPickUpETA,
  loadPickUpETATimeSlot,
  loadDropOffETA,
  loadDropOffETATimeSlot,
  driverData,
}) {
  const trackingStatus = useMemo(() => {
    const fallback =
      shipmentStatus === ShipmentStatus.Posted
        ? TrackingStatus.AssignedToDriver
        : null;
    return LoadStatusToTrackingStatusMap[loadStatus] ?? fallback;
  }, [shipmentStatus, loadStatus]);

  const title = useMemo(() => {
    const fallback =
      shipmentStatus === ShipmentStatus.Delivered ? "Delivered" : "";
    return LoadStatusMap[loadStatus] ?? fallback;
  }, [shipmentStatus, loadStatus]);

  return (
    <Card>
      <div style={{ width: "100%", textAlign: "center" }}>
        <Title level={3}>{title}</Title>
      </div>
      <Steps
        style={{
          marginBottom: 32,
        }}
        current={trackingStatus}
      >
        <Steps.Step title="Assigned to Driver" />
        <Steps.Step title="In Transit" />
        <Steps.Step title="Delivered" />
      </Steps>
      <Divider
        style={{
          marginBottom: 32,
        }}
      />
      <PickupDropOffSteps
        pickupAddress={pickupAddress}
        dropOffAddress={dropOffAddress}
      />
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <VehiclesTable data={vehicles} />
          <DriverTable data={[driverData]} />
        </Col>
        <Col xs={24} sm={24} md={12}>
          <GoogleMap
            pickupAddress={pickupAddress}
            dropOffAddress={dropOffAddress}
            loadLocation={loadLocation}
            showMarker={shipmentStatus === ShipmentStatus.Assigned}
          />
        </Col>
      </Row>
      <Divider
        style={{
          marginBottom: 32,
          marginTop: 80,
        }}
      />
      <ETAsDescription
        loadStatus={loadStatus}
        loadPickupETA={loadPickUpETA}
        loadPickupETATimeSlot={loadPickUpETATimeSlot}
        loadDropOffETA={loadDropOffETA}
        loadDropOffETATimeSlot={loadDropOffETATimeSlot}
      />
      <Divider
        style={{
          marginBottom: 32,
        }}
      />
    </Card>
  );
});
